<static-hdr></static-hdr>

<section class="container my-10" [@routerTransition]>
    <!-- Header: Breadcrumbs and Title (Same as List) -->

    <div class="row mb-5">
        <div class="col-12 d-flex justify-content-between align-items-center">
            <h1 class="font-weight-bold text-dark display-4">مركز المعرفة</h1>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb bg-transparent px-0 mb-0">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/home']" class="text-muted">المركز السعودي لكفاءة الطاقة</a>
                    </li>
                    <!-- <li class="breadcrumb-item">
                        <a href="javascript:;" class="text-muted">المركز الإعلامي</a>
                    </li> -->
                    <li class="breadcrumb-item active text-primary font-weight-bold" aria-current="page">مركز المعرفة
                    </li>
                </ol>
            </nav>
        </div>
    </div>
    <!-- Loading Spinner -->
    <div *ngIf="!active" class="text-center py-20">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">جاري التحميل...</span>
        </div>
    </div>

    <div class="row" *ngIf="active">




        <!-- Sidebar -->
        <div class="col-md-4 order-md-2 mb-6">

            <div class="kb-sidebar-card p-5">

                <!-- Scope -->
                <div class="sidebar-item mb-4 d-flex">
                    <i class="fa fa-user lightGreen ml-3 fa-2x"></i>
                    <div class="d-flex flex-column ml-3">
                        <div class="fw-bold mb-1">نطاق عمل اللائحة</div>
                        <div class="text-muted">
                            {{ getCategoryLabel(item?.knowledgeBank?.category) || 'عام' }}
                        </div>
                    </div>
                </div>

                <!-- Date -->
                <div class="sidebar-item mb-4 d-flex">
                    <i class="fa fa-calendar lightGreen ml-3 fa-2x"></i>
                    <div class="d-flex flex-column ml-3">
                        <div class="fw-bold mb-1">تاريخ إصدار اللائحة</div>
                        <div class="text-muted">
                            {{ creationTimeJsDate | date:'yyyy/MM/dd' }}
                        </div>
                    </div>
                </div>

                <hr>

                <div class="d-flex flex-column py-5">
                    <div class="mb-5 d-flex">
                        <i class="fa fa-external-link lightGreen ml-3 fa-2x"></i>
                        <div class="d-flex flex-column ml-3 mb-2">
                            <h5 class="font-weight-bolder text-dark mb-0">{{l('الاسئلة الشائعة')}}</h5>
                            <a class="d-block mt-2 lightGreen font-weight-bold mr-9" href="javascript:;">
                                صفحه الاسئلة الشائعة
                            </a>
                        </div>
                    </div>
                    <div class="mb-5 d-flex">
                        <i class="fa fa-phone lightGreen ml-3 fa-2x"></i>
                        <div class="d-flex flex-column ml-3 mb-2">
                            <h5 class="font-weight-bolder text-dark mb-0">{{l('ContactCenterNumber')}}</h5>
                            <a class="d-block mt-2 lightGreen font-weight-bold mr-9" href="javascript:;">
                                {{viewContactUs.contactUs?.contactCenterNumber}}
                            </a>
                        </div>
                    </div>
                    <div class="mb-5 d-flex">
                        <i class="fa fa-envelope lightGreen ml-3 fa-2x"></i>
                        <div class="d-flex flex-column ml-3 mb-2">
                            <h5 class="font-weight-bolder text-dark mb-0">{{l('ContactCenterEmailAddress')}}</h5>
                            <a class="d-block mt-2 lightGreen font-weight-bold " href="javascript:;">
                                {{viewContactUs.contactUs?.contactCenterEmail}}
                            </a>
                        </div>
                    </div>

                </div>

            </div>

        </div>


        <div class="col-md-8 order-md-1">

            <!-- Header Box -->
            <div class="kb-header-box p-5 mb-6">

                <div class="d-flex justify-content-between align-items-start flex-wrap gap-3">

                    <div class="">
                        <h2 class="kb-title mb-3">
                            {{ item?.knowledgeBank?.title }}
                        </h2>

                        <p class="kb-short-desc mb-0" [innerHTML]="item?.knowledgeBank?.description">
                        </p>
                    </div>

                    <div class="d-flex flex-column align-items-start">
                        <a href="javascript:;" *ngIf="attachmentsList?.length"
                            (click)="downloadAttachment(attachmentsList[0])" class="px-4 py-3 mb-3">
                            تحميل الملف
                        </a>
                    </div>

                </div>

                <!-- Share & Print -->
                <div class="d-flex justify-content-end text-dark gap-2 mt-4">
                    <button class="btn border text-dark d-flex align-items-center" (click)="close()">
                        <i class="fa fa-share ml-2 text-dark"></i>
                        مشاركة
                    </button>
                    <button class="btn border text-dark d-flex align-items-center" (click)="print()">
                        <i class="fa fa-print ml-2 text-dark"></i>
                        طباعة
                    </button>
                </div>

            </div>

            <!-- Full Description -->
            <!-- <div class="kb-content-body">
                <div [innerHTML]="item?.knowledgeBank?.description"></div>
            </div> -->

            <!-- Back -->
            <!-- <div class="mt-10 text-end">
                <button class="btn btn-outline-primary rounded-pill px-5" (click)="close()">
                    العودة لمركز المعرفة
                </button>
            </div> -->

        </div>





    </div>



</section>

<static-ftr></static-ftr>